// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        suggestionMobileStyle: 'style1'
    }
};

// Override Settings
(function () {  // Add this
  BoostPFS.inject(this);  // Add this

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
  };
  InstantSearchMobile.prototype.afterBindEvents = function() {
    var self = this;

    jQ('.header__action-item-link[data-action="toggle-search"]').off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ('.search-bar__input').focus();
      self.openSuggestionMobile();
    });

  }
  InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function(isClose) {
    //Fix conflict with theme search #593746
    jQ('.header__search-bar-wrapper').removeClass('is-fixed');
    jQ('.header__search-bar-wrapper').addClass('is-visible');
    jQ('header.header.header--inline').addClass('header--search-expanded');
  }

  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function () {
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		// Format price
		var price = Utils.formatMoney(this.data.price_min);
		var compareAtPrice = '';
		if (this.data && this.data.compare_at_price_min) {
			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}

        var variant = this.data.variants.find(e => e.available == true && parseFloat(e.price) > 0);
        if (typeof variant != 'undefined') {
          price = Utils.formatMoney(parseFloat(variant.price));
          if (variant.compare_at_price != '') {
            onSale = parseFloat(variant.compare_at_price) > parseFloat(variant.price);
            compareAtPrice = Utils.formatMoney(parseFloat(variant.compare_at_price));
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
          } else {
            compareAtPrice = '';
            onSale = false;
          }
          
        }
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
	}


})();  // Add this at the end